// Components
import Login from '../Login';
import InternalContainer from '../InternalContainer';
import ArtSearchBar from '../ArtSearchBar';
import Metasearcher from '../Metasearcher';
import JobsSearchBar from '../JobsSearchBar';
import LibraryVideoSearchBar from '../LibraryVideoSearchBar';
import InterestingLinksSearchBar from '../InterestingLinksSearchBar';
import Language from '../Language/';
// Redux
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
// Services
import {
	getSectionsInstitutions,
	getSectionsWithoutNavbar,
} from '../../services/getSectionsInstitutions';
// Styles
import './SearchBar.css';
import HeartIconBig from '../../Images/Login/Modal/heartIconBig.svg';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const SearchBar = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const currentlyRoute = pathname.replace('/', '');
	const { isAuth } = useAuth();
	// Get sections without nabvar in the view
	const sectionsWithoutNavbar = getSectionsWithoutNavbar();

	// Slices
	const { institutionCode, ebooksAccess, requestLogin } = useSelector(
		(state) => state.institution,
	);
	const sectionsMetasearcher = getSectionsInstitutions(
		institutionCode,
		ebooksAccess,
	)[0].data.map((objeto) => objeto.route);

	const handleMetasearchBar = () => {
		if (sectionsMetasearcher.includes(currentlyRoute)) {
			return <Metasearcher />;
		} else if (currentlyRoute === 'art') {
			return <ArtSearchBar />;
		} else if (currentlyRoute === 'jobs') {
			return <JobsSearchBar />;
		} else if (currentlyRoute === 'video-library') {
			return <LibraryVideoSearchBar />;
		} else if (currentlyRoute === 'interesting-links') {
			return <InterestingLinksSearchBar />;
		} else {
			return null;
		}
	};

	if (!sectionsWithoutNavbar.includes(currentlyRoute)) {
		return (
			<div className='searchBar'>
				<InternalContainer className='searchBarFull'>
					<div className='searchBarContainer'>{handleMetasearchBar()}</div>
					<div
						className={
							requestLogin ? 'optionsSearchBar' : 'optionsSearchBar noLogging'
						}
					>
						<Link className='tutorialsHeaderButton' to='/tutorials'>
							{t('Tutorials')}
						</Link>
						<div className='languageContainerDesktop'>
							<Language />
						</div>
						{isAuth() && (
							<div className='metasearcherLogin'>
								<div className='my-favorites-btn'>
									<Link to='/my-favorites'>
										<button>
											<img src={HeartIconBig} alt='heart icon' />
										</button>
									</Link>
								</div>
								<Login />
							</div>
						)}
					</div>
				</InternalContainer>
			</div>
		);
	}
};

export default SearchBar;
